/**
 * @generated SignedSource<<ffcd6a98199094474e01d2df04a178ec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type hooksCreateApiKeyPrivilegedMutation$variables = {
  name: string;
};
export type hooksCreateApiKeyPrivilegedMutation$data = {
  readonly createPrivilegedApiKey: {
    readonly token: string;
  } | null;
};
export type hooksCreateApiKeyPrivilegedMutation = {
  response: hooksCreateApiKeyPrivilegedMutation$data;
  variables: hooksCreateApiKeyPrivilegedMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      }
    ],
    "concreteType": "CreatePrivilegedApiKey",
    "kind": "LinkedField",
    "name": "createPrivilegedApiKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "hooksCreateApiKeyPrivilegedMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "hooksCreateApiKeyPrivilegedMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2b73e6219c8f28f806a43aeba86d20b8",
    "id": null,
    "metadata": {},
    "name": "hooksCreateApiKeyPrivilegedMutation",
    "operationKind": "mutation",
    "text": "mutation hooksCreateApiKeyPrivilegedMutation(\n  $name: String!\n) {\n  createPrivilegedApiKey(name: $name) {\n    token\n  }\n}\n"
  }
};
})();

(node as any).hash = "bb5687b9baa853896d3a9377fbb99af6";

export default node;
